import { render, staticRenderFns } from "./VInputFile.vue?vue&type=template&id=755d1211&"
import script from "./VInputFile.vue?vue&type=script&lang=js&"
export * from "./VInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports